import styled from '@emotion/styled';

export const Container = styled.div`
  background: #333;
  width: 350px;
  height: 200px;
`;
